"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BodyTable;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = _interopRequireWildcard(require("react"));
var _measureScrollbar = _interopRequireDefault(require("../../_util/measureScrollbar"));
var _BaseTable = _interopRequireDefault(require("./BaseTable"));
var _TableContext = _interopRequireDefault(require("./TableContext"));
function BodyTable(props) {
  var table = (0, _react.useContext)(_TableContext["default"]);
  var _table$props = table.props,
    prefixCls = _table$props.prefixCls,
    scroll = _table$props.scroll;
  var columns = props.columns,
    fixed = props.fixed,
    resizable = props.resizable,
    tableClassName = props.tableClassName,
    getRowKey = props.getRowKey,
    handleBodyScroll = props.handleBodyScroll,
    handleWheel = props.handleWheel,
    expander = props.expander,
    isAnyColumnsFixed = props.isAnyColumnsFixed;
  var saveRef = table.saveRef,
    columnManager = table.columnManager;
  var useFixedHeader = table.props.useFixedHeader;
  var bodyStyle = (0, _objectSpread2["default"])({}, table.props.bodyStyle);
  var innerBodyStyle = {};
  if (scroll.x || fixed || resizable) {
    bodyStyle.overflowX = bodyStyle.overflowX || 'auto'; // Fix weired webkit render bug

    bodyStyle.WebkitTransform = 'translate3d (0, 0, 0)';
  }
  if (scroll.y) {
    // maxHeight will make fixed-Table scrolling not working
    // so we only set maxHeight to body-Table here
    if (fixed) {
      innerBodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
      innerBodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
    } else {
      bodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
    }
    bodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
    useFixedHeader = true; // Add negative margin bottom for scroll bar overflow bug

    var scrollbarWidth = (0, _measureScrollbar["default"])();
    if (scrollbarWidth > 0 && fixed) {
      bodyStyle.marginBottom = "-".concat(scrollbarWidth, "px");
      bodyStyle.paddingBottom = '0px';
    }
  }
  var hasFoot = !useFixedHeader && columnManager.hasFooter();
  var baseTable = /*#__PURE__*/_react["default"].createElement(_BaseTable["default"], {
    tableClassName: tableClassName,
    hasHead: !useFixedHeader,
    hasBody: true,
    hasFoot: hasFoot,
    fixed: fixed,
    columns: columns,
    expander: expander,
    getRowKey: getRowKey,
    isAnyColumnsFixed: isAnyColumnsFixed
  });
  if (fixed && columns.length) {
    var refName;
    if (columns[0].fixed === 'left' || columns[0].fixed === true) {
      refName = 'fixedColumnsBodyLeft';
    } else if (columns[0].fixed === 'right') {
      refName = 'fixedColumnsBodyRight';
    }
    delete bodyStyle.overflowX;
    delete bodyStyle.overflowY;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "bodyTable",
      className: "".concat(prefixCls, "-body-outer"),
      style: (0, _objectSpread2["default"])({}, bodyStyle)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(prefixCls, "-body-inner"),
      style: innerBodyStyle,
      ref: saveRef(refName),
      onWheel: handleWheel,
      onScroll: handleBodyScroll
    }, baseTable));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    key: "bodyTable",
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle,
    ref: saveRef('bodyTable'),
    onWheel: handleWheel,
    onScroll: handleBodyScroll
  }, baseTable);
}